<div class="not-found">
  <div class="not-found__content">
    <img class="not-found__logo" src="assets/layout/images/splash.png" [alt]="brandName" />

    <p class="not-found__code">404</p>
    <h1 class="not-found__title">{{ 'notFound.title' | transloco }}</h1>
    <p class="not-found__text">{{ 'notFound.text' | transloco }}</p>

    <div class="not-found__actions">
      <button type="button" class="not-found__btn not-found__btn--primary" (click)="handleGoHome()">
        {{ 'notFound.backButton' | transloco }}
      </button>
      <button type="button" class="not-found__btn not-found__btn--ghost" (click)="handleGoBack()">
        {{ 'notFound.previousPage' | transloco }}
      </button>
    </div>
  </div>
</div>
